import actionTypes from '../constants/action-types';

const setCurrentTheme = (currentTheme) => ({
  type: actionTypes.SET_CURRENT_THEME,
  payload: {
    currentTheme,
  },
});

export default setCurrentTheme;
